/**
 * 本文の大きい手続きを受ける口。既定の口 (/trpc) とは別に /trpc/bulk を設け、そこだけ本文の上限を上げる。
 * 画面の tRPC の link は、手続きのパスでどちらの口に送るかを決める。frontend からも読むため、依存を持たない。
 */

/** 本文の上限を上げた口の、/trpc の下の接頭辞 */
export const BULK_TRPC_PREFIX = "bulk";

/**
 * 本文の上限を上げた口の本文の上限。Next の proxy が中継できる本文の上限 (10MB) に合わせる。
 * パートファイルなどのテキストの合計 (8MB まで) を、JSON の書き方による増え分を見込んでも送れる大きさ。
 */
export const BULK_BODY_LIMIT_BYTES = 10 * 1024 * 1024;

/** 本文の上限を上げた口に送る手続きのパス */
export const BULK_PROCEDURE_PATHS: readonly string[] = [
  "systemAdmin.learningContentImport.preview",
  "systemAdmin.learningContentImport.renderPart",
  "systemAdmin.learningContentImport.import",
  "manager.learningContentImport.preview",
  "manager.learningContentImport.renderPart",
  "manager.learningContentImport.import",
];
